//CHECKS Listing
export const FETCH_CHECKS_LISTING_SUCCESS = 'FETCH_CHECKS_LISTING_SUCCESS';
export const FETCH_CHECKS_LISTING_FAILURE = 'FETCH_CHECKS_LISTING_FAILURE';

export const RESET = 'RESET';
